import "./GCodeSettingsBlock.css"
import InputNumberProperty from "../properties/basic/InputNumberProperty";
import React from "react";
import {gCodeParametersStore} from "../../stores/GCodeParametersStore";
import {observer} from "mobx-react-lite";
import Divider20 from "../properties/basic/Divider20";
import DrillTypeSelector from "./DrillTypeSelector";
import BooleanProperty from "../properties/basic/BooleanProperty";

function GCodeSettingsBlock() {

    function updateParameter(name: string, newVal: any) {
        let newParameters: any = {
            ...gCodeParametersStore.getParameters()
        }
        newParameters[name] = newVal
        gCodeParametersStore.setParameters(newParameters)
    }

    const inputAdditionalClass: string = "input110"

    return <>
        <div className={"scrolled-v-panel"}>
            <Divider20 empty={true}/>
            <InputNumberProperty
                label={"Plate thickness"}
                val={gCodeParametersStore.getParameters().plateThickness}
                onChange={value => updateParameter("plateThickness", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
            <InputNumberProperty
                label={"Milling depth"}
                val={gCodeParametersStore.getParameters().millingDepth}
                onChange={value => updateParameter("millingDepth", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
            <InputNumberProperty
                label={"Milling speeed"}
                val={gCodeParametersStore.getParameters().millingSpeed}
                onChange={value => updateParameter("millingSpeed", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
            <InputNumberProperty
                label={"Move height"}
                val={gCodeParametersStore.getParameters().moveHeight}
                onChange={value => updateParameter("moveHeight", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
            <InputNumberProperty
                label={"Tool change height"}
                val={gCodeParametersStore.getParameters().toolChangeHeight}
                onChange={value => updateParameter("toolChangeHeight", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
            <InputNumberProperty
                label={"Cut depth offset"}
                val={gCodeParametersStore.getParameters().offsetOnDrillCutDepth}
                onChange={value => updateParameter("offsetOnDrillCutDepth", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
            <InputNumberProperty
                label={"Hole diameter diff"}
                val={gCodeParametersStore.getParameters().holeDiameterOffset}
                onChange={value => updateParameter("holeDiameterOffset", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
            <InputNumberProperty
                label={"Skip first N holes"}
                val={gCodeParametersStore.getParameters().skipFirstN}
                onChange={value => updateParameter("skipFirstN", Math.max(0, Math.floor(value)))}
                inputAdditionalClassName={inputAdditionalClass}
            />

            <DrillTypeSelector
                drillType={gCodeParametersStore.getParameters().drillType}
                onChange={value => updateParameter("drillType", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />

            <BooleanProperty
                label={"Use separate files"}
                val={gCodeParametersStore.getParameters().useSeparateFiles}
                onChange={value => updateParameter("useSeparateFiles", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />

            <InputNumberProperty
                label={"cutStep"}
                val={gCodeParametersStore.getParameters().cutStep}
                onChange={value => updateParameter("cutStep", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />

            <InputNumberProperty
                label={"Bridge heights"}
                val={gCodeParametersStore.getParameters().bridgeHeightPercentage}
                onChange={value => updateParameter("bridgeHeightPercentage", value)}
                inputAdditionalClassName={inputAdditionalClass}
            />
        </div>
    </>
}

export default observer(GCodeSettingsBlock)